import { createContextAwareHook } from './useContextAwareHook';
import {
  useGetGrasslandsQuery,
  usePublicGetGrasslandsQuery,
  useGetGrasslandsDefaultsQuery,
  usePublicGetGrasslandsDefaultsQuery,
  useUpdateGrasslandsMutation
} from '../features/modules/grasslandApiSlice';

/**
 * Returns a hook that automatically selects between public and private APIs
 * for getting grasslands data based on the current route.
 */
export const useContextAwareGetGrasslands = createContextAwareHook(
  useGetGrasslandsQuery,
  usePublicGetGrasslandsQuery
);

/**
 * Returns a hook that automatically selects between public and private APIs
 * for getting grasslands defaults based on the current route.
 */
export const useContextAwareGetGrasslandsDefaults = createContextAwareHook(
  useGetGrasslandsDefaultsQuery,
  usePublicGetGrasslandsDefaultsQuery
);

// Export mutation hooks directly
export {
  useUpdateGrasslandsMutation
}; 